import { AnyObject, Optional } from '@vimeo/core/types/generic';

/**
 * JSON.stringify replacer which omits any objects with circular dependencies
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value#examples
 *
 * @param replacer - value to use as replacement mark
 * @returns factory to process key-values during JSON object serialization
 */
export function getCircularReplacer(replacer: Optional<string> = '~circular~') {
  const seen: WeakSet<AnyObject> = new WeakSet();

  return (_: string, value: unknown) => {
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) {
        return replacer;
      }

      seen.add(value);
    }
    return value;
  };
}
